import React from 'react'
import { useSelector } from 'react-redux'
import { BounceLoader } from 'react-spinners'

const Loader = () => {
  const loader = useSelector((states: any) => states.loaderState)
  return (
    loader && (
      <div className="components__loader">
        <div className="components__loader-spinner">
          <BounceLoader color="#36d7b7" />
        </div>
      </div>
    )
  )
}

export default Loader
